import { useTranslation } from 'react-i18next';

export default function BenefitsSection() {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: 'ri-time-line',
      title: t('benefits.reduce'),
      description: t('benefits.reduce.desc'),
      color: 'bg-blue-600'
    },
    {
      icon: 'ri-arrow-down-line',
      title: t('benefits.cost'),
      description: t('benefits.cost.desc'),
      color: 'bg-green-600'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: t('benefits.affordable'),
      description: t('benefits.affordable.desc'),
      color: 'bg-purple-600'
    },
    {
      icon: 'ri-trending-up-line',
      title: t('benefits.improves'),
      description: t('benefits.improves.desc'),
      color: 'bg-orange-600'
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-cyan-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            {t('benefits.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center">
              <div className={`w-16 h-16 ${benefit.color} rounded-full flex items-center justify-center mx-auto mb-6`}>
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">{benefit.title}</h3>
              <p className="text-cyan-100 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}